import { Link } from 'react-router';
import PropTypes from 'prop-types';

import { openPopup } from 'helpers';
import css from 'styles/containers/returns/doneSection.scss';
import marketplace from 'cfg/marketplace.json';

const DoneSection = ({ postReturnInfo, boxInfo }) => {
  const { account: { returnLabelUrl, zenReturnConfirmationLayout }, returns: { returnPolcyUrl } } = marketplace;
  const singleBox = Object.keys(boxInfo).length === 1;

  /*
  * Because there currently isn't a way to associate which return label goes with which box based on
  * the data we get back from the submitReturn endpoint, we have to make the association ourselves on the client.
  */
  const makeReturnLabels = () => {
    const returnLabels = [];
    for (const box in boxInfo) { // select item from each individual box (doesn't matter which so let's use the first) and get its unitId
      const unitIdInBox = boxInfo[box].items[0].unitId;
      const matchingItem = postReturnInfo.find(indvReturn => { // find item within postReturnInfo object that has matching unitId
        const { returnItems } = indvReturn;
        return returnItems.find(item => {
          const { unitId } = item;
          return unitId === unitIdInBox;
        });
      });
      // we can then associate the postReturnInfo item's contractId/rmaId with that specific box and display box-associated returnLabel
      if (matchingItem) {
        const { rmaId, contractId } = matchingItem;
        const printLabelButton = (<a
          href={`${returnLabelUrl}?contractId=${contractId}&displayInfo=true`}
          className={css.print}
          data-popup-options="width=1000,height=800"
          onClick={openPopup}>{singleBox ? 'Print Return Label' : `Print Label for Box ${box}`}</a>);
        zenReturnConfirmationLayout ?
          returnLabels.push(
            <div className={css.returnLabel} key={rmaId}>
              <div>
                <h3>Print Your Return Label</h3>
                {printLabelButton}
              </div>
              <div>
                <h3>Return Confirmation Number</h3>
                <p>{rmaId}</p>
              </div>
              <div>
                <h3>Original Order Number</h3>
                <p>Order#: {matchingItem.orderId}</p>
              </div>
            </div>
          )
          :
          returnLabels.push(
            <div className={css.returnLabel} key={rmaId}>
              <p>{rmaId}</p>
              {printLabelButton}
            </div>
          );
      }
    }
    return (<div className={css.returnLabels}>{returnLabels}</div>);
  };

  return (
    <section className={css.container}>
      <h1>Your return is confirmed</h1>
      <div className={css.confirmation}>
        {zenReturnConfirmationLayout ? (<h2>Return Confirmation Information</h2>) : (<h2>Return Confirmation Numbers</h2>)}
        {makeReturnLabels()}
        <p>
          <Link to={returnPolcyUrl}>Our return policy</Link>
        </p>
      </div>
    </section>
  );
};

DoneSection.propTypes = {
  postReturnInfo: PropTypes.array.isRequired
};

export default DoneSection;
